<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="海报名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入海报名称" :clearable="true"></el-input>
      </el-form-item>
      <div class="textImg">
        <div class="map">
          <div
            v-if="showElements"
            id="app"
            :style="{width:form.width + 'px',height:form.height+'px'}"
          >
            <img class="images" :src="form.bgImg" ref="element" x="0" y="0" alt />
            <!-- @click="getImageSize($event)" -->
            <VueDragResize
              v-for="(item,index) in form.elements"
              :key="index"
              :isActive="true"
              :isResizable="true"
              :parentLimitation="true"
              :aspectRatio="true"
              :w="item.width"
              :h="item.height"
              :x="item.left"
              :y="item.top"
              v-on:resizing="changePosition($event, index)"
              v-on:dragging="changePosition($event, index)"
            >
              <div
                v-if="item.type==0"
                class="name"
                :style="{transform:'rotate(' + item.degree + 'deg)', fontSize:item.fontSize + 'px',color:item.color,width:(indesx == index ?(item.width + 'px'): (item.width+ 'px')),height:(indesx == index ?(item.height + 'px'): (item.height+ 'px'))}"
              >昵称</div>
              <img
                v-if="item.type == 2"
                class="imgtype"
                :style="{width:(indesx == index ?(item.width + 'px'): (item.width+ 'px')),height:(indesx == index ?(item.height + 'px'): (item.height+ 'px'))}"
                src="https://oss.lifeinmark.com/132.jpg"
              />
              <img
                v-if="item.type == 1"
                class="imgl"
                :style="{width:(indesx == index ?(item.width + 'px'): (item.width+ 'px')),height:(indesx == index ?(item.height + 'px'): (item.height+ 'px'))}"
                src="https://oss.lifeinmark.com/1662615983106.jpg"
              />
            </VueDragResize>
          </div>
          <el-upload
            style="position: relative;margin-top:20px"
            class="avatar-uploader"
            :action="uploadUrl"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :show-file-list="false"
            list-type="picture-card"
            :limit="10"
            :data="uploadData"
            :on-success="handleAvatarSuccess"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              <span>图片要求:</span>
              <span v-for="(vv, ii) in introduce" :key="ii">{{ii + 1}}.{{vv}}</span>
              <span>{{introduce.length + 1}}.最多上传1张</span>
            </div>
          </el-upload>
        </div>
        <div class="imgitem" v-if="form.bgImg != ''">
          <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
            <div
              style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
            >元素</div>
            <el-collapse accordion>
              <el-collapse-item v-for="(item, index) in form.elements" :key="index">
                <span
                  style="font-size:15px;font-weight:600; margin:20px;"
                  slot="title"
                >元素{{index + 1}}</span>
                <el-form-item label="元素类型" required>
                  <el-radio-group v-model="item.type">
                    <el-radio :label="0">用户昵称</el-radio>
                    <el-radio :label="1">小程序码</el-radio>
                    <el-radio :label="2">头像</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  v-if="item.type == 0"
                  label="字体大小"
                  required
                  :prop="'elements.' + index + '.fontSize'"
                  :rules="[
            { required: true, message: '字体大小不能为空', trigger: 'blur' },
      { type: 'number', message: '字体大小必须为数字值' },
            ]"
                >
                  <el-input v-model.number="item.fontSize" :clearable="true"></el-input>
                </el-form-item>
                <el-form-item
                  v-if="item.type == 0"
                  label="旋转角度(负值向左旋转)"
                  required
                  :prop="'elements.' + index + '.degree'"
                  :rules="[
            { required: true, message: '旋转角度不能为空', trigger: 'blur' },
      { type: 'number', message: '旋转角度必须为数字值' },
            ]"
                >
                  <el-input v-model.number="item.degree" :clearable="true"></el-input>
                </el-form-item>
                <el-form-item label="字体颜色" required v-if="item.type == 0">
                  <el-color-picker v-model="item.color"></el-color-picker>
                </el-form-item>
                <el-form-item label="宽" required v-if="mapHide">
                  <el-input v-model="item.width" :clearable="true" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="高" required v-if="mapHide">
                  <el-input v-model="item.height" :clearable="true" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="距左边坐标" required v-if="mapHide">
                  <el-input v-model="item.left" :clearable="true" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="距顶部坐标" required v-if="mapHide">
                  <el-input v-model="item.top" :clearable="true" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="跳转地址" required>
                  <jumpType2 :Jumpurls="item.Jumpurl"></jumpType2>
                </el-form-item>
                <div style="text-align: center;margin-bottom: 10px;">
                  <el-button type="danger" size="mini" @click="removeList(index)">删除元素</el-button>
                </div>
              </el-collapse-item>
              <div style="text-align: center;margin-top: 10px;">
                <el-button type="primary" size="mini" @click="addList()">添加元素</el-button>
              </div>
            </el-collapse>
          </div>
        </div>
      </div>
    </el-form>
    <div class="footer" v-if="mapTrue">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">新 增</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="success" @click="getModify('form')">编 辑</el-button>
    </div>
  </d2-container>
</template>
<script>
import { getToken } from '@/api/demo/classification/index'
import {
  getAddPoster,
  getPosterInfo,
  getAddPosterUpdate
} from '@/api/demo/poster/index'

import VueDragResize from 'vue-drag-resize'
import jumpType2 from '@/components/jumpType/jumpType.vue'
export default {
  name: 'posterEditor',
  components: {
    VueDragResize,
    jumpType2
  },
  data () {
    return {
      mapHide: false,
      showElements: true,
      mapTrue: true,
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      introduce: ['图片大小500kb以内', '图片格式png/jpg/gif'],
      indesx: '',
      form: {
        bgImg: '', // 背景图片
        height: '', // 高度
        name: '', // 海报名称
        width: '', // 宽度
        elements: []
      },
      posterId: '', // 详情id
      rules: {
        name: [
          {
            required: true,
            message: '请输入海报名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.posterId = this.$route.query.id
    if (that.posterId != null) {
      that.getInfo(that.posterId)
      that.mapTrue = false
    } else {
    }
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
  },
  methods: {
    getInfo (posterId) {
      let that = this
      getPosterInfo(posterId).then(res => {
        res.elements.map(item => {
          item.paramType = item.paramType
          item.paramValue = item.paramValue
          item.url = item.url
          item.skipType = item.skipType
          item.Jumpurl = {
            url: item.url,
            id: parseInt(item.skipType),
            classId: null,
            paramType: item.paramType,
            value: item.paramValue
          }
        })
        that.form = res
      })
    },
    addList () {
      this.form.elements.push({
        color: '#ffffff', // 颜色 16进制
        fontSize: '', // 字体大小
        height: 50, // 高度
        left: 0, // 距离右边位置
        top: 0, // 距离顶部位置
        type: 0, // 元素类型 0 用户昵称 1 小程序码
        width: 50, // 宽度
        degree: -8, // 旋转角度 负值向左旋转
        paramType: '',
        paramValue: '',
        skipType: '',
        url: '',
        Jumpurl: {
          url: '',
          id: 13,
          classId: null,
          paramType: '0',
          value: ''
        }
      })
    },
    removeList (index) {
      this.showElements = false
      this.form.elements.splice(index, 1)
      this.$nextTick(() => {
        this.showElements = true
      })
    },
    // 七牛上传图片
    handleAvatarSuccess (res, file) {
      let that = this
      that.form.bgImg = that.https + '/' + res.key
    },
    uploadError (err, file) {
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    beforeAvatarUpload (file) {
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
      // 定义 filereader对象
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = e => {
        const img = e.target.result
        const image = new Image()
        image.src = img

        image.onload = _ => {
          this.form.width = image.width
          this.form.height = image.height
        }
      }
    },
    changePosition (newRect, index) {
      // console.log("--newRect", newRect, index);
      this.form.elements[index].width = newRect.width
      this.form.elements[index].height = newRect.height
      this.form.elements[index].top = newRect.top
      this.form.elements[index].left = newRect.left
      this.indesx = index
      // console.log("this.width", this.form.elements);
    },
    // 取消
    cancel () {
      let that = this
      that.$router.back()
    },
    // 新增
    getCreate (forms) {
      let that = this
      this.$refs[forms].validate(async valid => {
        if (valid) {
          that.form.elements.forEach(items => {
            items.paramType = items.Jumpurl.paramType
            items.skipType = items.Jumpurl.id
            items.url = items.Jumpurl.url
            items.paramValue = items.Jumpurl.value
          })
          await getAddPoster(that.form)
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
        }
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      this.$refs[forms].validate(async valid => {
        if (valid) {
          that.form.elements.forEach(items => {
            items.paramType = items.Jumpurl.paramType
            items.skipType = items.Jumpurl.id
            items.url = items.Jumpurl.url
            items.paramValue = items.Jumpurl.value
          })
          await getAddPosterUpdate(that.posterId, that.form)
          that.$notify({
            title: '成功',
            message: '编辑成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
        }
      })
    }
  }
}
</script>
<style  scoped>
#app {
  width: 0;
  height: 0;
  position: relative;
  overflow: hidden;
  margin: 0;
  box-sizing: border-box;
  border: 1px solid;
}
.textImg {
  display: flex;
  justify-content: center;
}
.imgitem {
  width: 900px;
  margin-left: 100px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
.imgl {
  width: 100px;
  height: 100px;
}
.imgtype {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
/deep/ .el-collapse {
  border-bottom: 0px solid;
}
.avatar-uploader {
  display: flex;
}
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.el-upload__tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  line-height: 16px;
}
.name {
  font-weight: bold;
}
</style>
